import React, { useEffect, useMemo, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Slider from "rc-slider";
import "rc-slider/assets/index.css";

import { useAppDispatch } from "../hooks/useAppDispatch";
import { useAppSelector } from "../hooks/useAppSelector";

import {
  fetchAllCompanies,
  fetchAllEmployees,
} from "../store/slices/userSlice";

import calendar_icon from "../assets/images/calendar_icon.svg";

import CompanyListTable from "./tables/CompanyListTable";
import EmploayeListTable from "./tables/EmployeListTable";

import search_icon_new from "../assets/images/search_icon_new.svg";
import filter_list_icon from "../assets/images/filter_list_icon.svg";
import { formatDateForApi } from "../utils/dateUtils";

const ClientTabs = ({ clientId, activeTab, setActiveTab }) => {
  const dispatch = useAppDispatch();

  const COMPANY_PAGE_KEY = "clientDetailCompanies";
  const EMPLOYEE_PAGE_KEY = "clientDetailEmployees";

  const companyList = useAppSelector((s) => s.user.listDataByKey[COMPANY_PAGE_KEY] || []);
  const employeeList = useAppSelector((s) => s.user.listDataByKey[EMPLOYEE_PAGE_KEY] || []);

  const loadingCompanies = useAppSelector((s) => s.user.listLoadingByKey[COMPANY_PAGE_KEY] || false);
  const loadingEmployees = useAppSelector((s) => s.user.listLoadingByKey[EMPLOYEE_PAGE_KEY] || false);

  const totalCompanyRecords = useAppSelector((s) => s.user.totalByKey[COMPANY_PAGE_KEY] || 0);
  const totalEmployeeRecords = useAppSelector((s) => s.user.totalByKey[EMPLOYEE_PAGE_KEY] || 0);

  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("all");

  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const [payRange, setPayRange] = useState([0, 1000000]);

  const buildCompanyParams = (extra = {}) => {
    const params = {
      startDate: formatDateForApi(startDate),
      endDate: formatDateForApi(endDate),
      status: status === "all" ? null : status === "active" ? true : false,
      minPayAvg: payRange[0],
      maxPayAvg: payRange[1],
      ...extra,
    };

    if (search) {
      params.search = search;
    }

    return params;
  };

  useEffect(() => {
    if (!clientId) return;
    if ((startDate && !endDate) || (!startDate && endDate)) {
      return;
    }

    const t = setTimeout(() => {
      const params = buildCompanyParams({
        pageIndex: page - 1,
        pageSize: pageSize,
        clientId: clientId
      });


      dispatch(fetchAllCompanies({ params, key: COMPANY_PAGE_KEY }));

      dispatch(fetchAllEmployees({ params, key: EMPLOYEE_PAGE_KEY }));
    }, 400);

    return () => clearTimeout(t);
  }, [clientId, dispatch, search, startDate, endDate, page, status, payRange]);

  return (
    <div className="clint_tabs mt_30">
      <div className="container-fluid">

        <div className="filter_serach_postion col-6 mb_20">
          <div className="top_bar d-flex align-items-center w-100">
            <div className="search_field mr_20 col-6 ms-auto d-flex align-items-center">
              <input
                type="text"
                className="form-control"
                placeholder="Search Company & Employee"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="serach_icon">
                <img src={search_icon_new} alt="Search" />
              </span>
            </div>

            <div className="dropdown filter">
              <button
                className="btn btn_secondary"
                type="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <img src={filter_list_icon} alt="Filter" /> Filter
              </button>
              <div className="dropdown-menu p-3">
                <div className="datepickers">
                  <p className="fs_12 mb_6">Filter by Creation Date</p>
                  <div className="datepicker position-relative">
                    <DatePicker
                      selectsRange
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => setDateRange(update)}
                      dateFormat="MM/dd/yyyy"
                      className="form-control"
                      placeholderText="Choose date range"
                    />
                    <img
                      src={calendar_icon}
                      className="datepicker_icon"
                      alt="calendar"
                    />
                  </div>
                  {/* :moneybag: Pay Avg Range */}
                  <div className="mt_20">
                    <div className="d-flex justify-content-between align-items-center mb_10">
                      <p className="fs_12 mb-0">Pay Avg Range</p>
                      <span
                        className="fs_12 text-primary cursor-pointer"
                        onClick={() => setPayRange([0, 1000000])}
                      >
                        Clear
                      </span>
                    </div>
                    <Slider
                      range
                      min={0}
                      max={1000000}
                      step={500}
                      value={payRange}
                      onChange={setPayRange}
                      trackStyle={[
                        { backgroundColor: "#1E6BFF", height: 4 },
                      ]}
                      handleStyle={[
                        {
                          borderColor: "#1E6BFF",
                          height: 14,
                          width: 14,
                          backgroundColor: "#fff",
                        },
                        {
                          borderColor: "#1E6BFF",
                          height: 14,
                          width: 14,
                          backgroundColor: "#fff",
                        },
                      ]}
                      railStyle={{
                        backgroundColor: "#E0E0E0",
                        height: 4,
                      }}
                    />
                    <div className="d-flex justify-content-between fs_12 mt_6">
                      <span>${payRange[0].toLocaleString()}</span>
                      <span>${payRange[1].toLocaleString()}</span>
                    </div>
                  </div>
                  {/* :moneybag: End Pay Avg Range */}
                  <div className=" mt_16">
                    <p className="fs_12 mb_6">Status</p>
                    <select
                      className="form-select"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="all">All</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        { }
        <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>

          { }
          <Tab
            eventKey="companyList"
            title={`Companies (${totalCompanyRecords || 0})`}
          >
            <div className="white_box">
              <CompanyListTable
                data={companyList}
                loading={loadingCompanies}
                currentPage={page}
                pageSize={pageSize}
                totalRecords={totalCompanyRecords}
                onPageChange={(pageNumber) => setPage(pageNumber)}
                isDetailPage={true}
              />
            </div>
          </Tab>

          { }
          <Tab
            eventKey="employeeList"
            title={`Employees (${totalEmployeeRecords || 0})`}
          >
            <div className="white_box">
              <EmploayeListTable
                data={employeeList}
                loading={loadingEmployees}
                currentPage={page}
                pageSize={pageSize}
                totalRecords={totalEmployeeRecords}
                onPageChange={(pageNumber) => setPage(pageNumber)}
                isDetailPage={true}
              />
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default ClientTabs;